module.exports = __webpack_public_path__ + "img/water.c186a36c.png";